import React, { useState } from 'react';

import {
  FormControl,
  Box,
  FormHelperText,
  Slider,
  Typography,
} from '@mui/material';

export default function MaxNewTokensField({ value, setValue, ...rest }) {
  const [initialValue] = useState(value);
  const handleChange = (event, newValue) => {
    setValue(parseInt(newValue));
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <Typography>Max New Tokens</Typography>
        <Slider
          {...rest}
          aria-label='Temperature'
          defaultValue={initialValue}
          valueLabelDisplay='auto'
          aria-describedby='max-new-tokens-helper-text'
          onChange={handleChange}
          min={0}
          max={1024}
        />

        <FormHelperText id='max-new-tokens-helper-text'>
          The maximum numbers of tokens to generate, ignoring the number of
          tokens in the prompt.
        </FormHelperText>
      </FormControl>
    </Box>
  );
}
